import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

const chipWrapperStyles = css`
  display: flex;
`

const chipStyles = (backgroundColor, textColor) => css`
  border-radius: 40px;
  background-color: ${backgroundColor};
  color: ${textColor};
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 4px;
  padding-inline-end: 10px;
  padding-bottom: 4px;
  padding-inline-start: 8px;
  font-size: 12px;
  line-height: 14px;
`

const colorMap = {
  green: {
    backgroundColor: colors.green03,
    textColor: colors.green60,
  },
  gray: {
    backgroundColor: colors.gray03,
    textColor: colors.gray60,
  },
  blue: {
    backgroundColor: colors.blue03,
    textColor: colors.blue60,
  },
  red: {
    backgroundColor: colors.red03,
    textColor: colors.red60,
  },
  yellow: {
    backgroundColor: colors.yellow03,
    textColor: colors.yellow60,
  },
}

export default function StatusChip({ color = 'gray', Icon, label }) {
  const { backgroundColor, textColor } = colorMap[color] || {}
  return (
    <div css={chipWrapperStyles}>
      <div css={chipStyles(backgroundColor, textColor)}>
        <Icon size="xs" />
        {label}
      </div>
    </div>
  )
}

StatusChip.propTypes = {
  color: PropTypes.oneOf(Object.keys(colorMap)).isRequired,
  Icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}
